import { createStore } from 'idb-keyval';

const trfImageStore = createStore('MRAT_TRF_IMAGE_DB', 'SRAFormImage');

export default trfImageStore;
